import React, { useState } from "react";
import { ChevronDown, ChevronUp } from "lucide-react";

/** Seção com seta para expandir/recolher (seta para baixo abre, para cima recolhe). Mostra todos os itens quando aberta. */
export function Recolhivel({ titulo, contagem, aberto: inicial = true, testid, children }) {
  const [aberto, setAberto] = useState(inicial);
  return (
    <div data-testid={testid}>
      <button type="button" onClick={() => setAberto(!aberto)} aria-expanded={aberto} className="w-full flex items-center justify-between gap-2 min-h-[44px] px-1 font-bold text-sm" data-testid={`${testid}-toggle`}>
        <span>{titulo}{contagem != null && <span className="ml-2 text-xs font-normal text-slate-500">({contagem})</span>}</span>
        {aberto ? <ChevronUp className="w-5 h-5 text-slate-500" /> : <ChevronDown className="w-5 h-5 text-slate-500" />}
      </button>
      {aberto && <div className="space-y-3 mt-1">{children}</div>}
    </div>
  );
}
